module.exports = __webpack_public_path__ + "assets/default-ico-pickdate.f3b03ee9.svg";